import { render, staticRenderFns } from "./token-input.vue?vue&type=template&id=abae4976"
import script from "./token-input.vue?vue&type=script&lang=ts"
export * from "./token-input.vue?vue&type=script&lang=ts"
import style0 from "./token-input.vue?vue&type=style&index=0&id=abae4976&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports